import { useState } from "react";
import { useStore } from '@nanostores/react';
import { arabicFontSettingsStore,englishFontSettingsStore } from "../../stores/sessionStore";
import ConfirmationModal from "../ui-elements/ConfirmationModal";

const MainMenu=({translationMenu,reciterMenu,recitationMenu,sectionSwitchFunc})=>{
    const[showFontResetModal,setShowFontResetModal]=useState(false);

    const englishFontSettings=useStore(englishFontSettingsStore);
    const arabicFontSettings=useStore(arabicFontSettingsStore);

    const settingsGlobal = [
        {
            id: "bookmarksLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showBookmarks();",
            icon: {
                src: "/images/bookmark-white.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Bookmarks"
        },
        {
            condition: translationMenu === '1',
            id: "translationSettingsLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showTransSetting();",
            icon: {
                src: "/images/bookmark-white.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Translation settings"
        },
        {
            condition: recitationMenu === '1',
            id: "recitationSettingsLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showReciteSetting();",
            icon: {
                src: "/images/bookmark-white.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Recitation settings"
        },
        {
            condition: reciterMenu === '1',
            id: "reciterMenuLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showReciterSetting();",
            icon: {
                src: "/images/bookmark-white.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Reciters list"
        },
        {
            id: "arabicFontSettingsLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showArbFontSetting();",
            icon: {
                src: "/images/arabic-font.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Arabic font settings"
        },
        {
            id: "englishFontSettingsLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            onclick: "showEngFontSetting();",
            icon: {
                src: "/images/english-font.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "English font settings"
        },
        {
            id: "resetFontSettingsLink",
            class: "flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer hover:bg-dark_blue",
            attributes: {
                "data-modal-target": "reset-settings-confirm",
                "data-modal-toggle": "reset-settings-confirm"
            },
            icon: {
                src: "/images/global-font.svg",
                width: 17,
                height: 17,
                alt: "Bookmark icon"
            },
            label: "Reset global font settings"
        }
    ];

    const loadDefaultFontSettings = () => {
        const tempFontSettings=JSON.parse(localStorage.getItem("fontSettings"));
        if(tempFontSettings!==null)
        {
            arabicFontSettingsStore.set({fontClass: getArabicFont(tempFontSettings.arabicFont), fontSizeClass: getFontSize(tempFontSettings.arabicFontSize)});
            englishFontSettingsStore.set({fontClass: getEnglishFont(tempFontSettings.englishFont), fontSizeClass: getFontSize(tempFontSettings.englishFontSize)});
        }
    }

    const resetFontSettings = () => {
        resetGlobalSettings();
        loadDefaultFontSettings();
        setShowFontResetModal(false);
    }

    return(
        <>
            <div className="pt-10">
                {settingsGlobal.map((setting,settingIndex) => (
                    (!("condition" in setting) || setting.condition) && (
                        <div
                            key={settingIndex}
                            id={setting.id}
                            className={setting.class}
                            onClick={()=>{
                                if(setting.id=="resetFontSettingsLink")
                                {
                                    // document.getElementById("reset-font-toggle").click();
                                    setShowFontResetModal(true);
                                }
                                else
                                {
                                    sectionSwitchFunc(settingIndex+1);
                                }
                            }}
                        >
                            <img
                                src={setting.icon.src}
                                width={setting.icon.width}
                                height={setting.icon.height}
                                alt={setting.icon.alt}
                            />
                            <span className="ml-3">{setting.label}</span>
                        </div>
                    )
                ))}
            </div>

            {
                showFontResetModal?
                    <ConfirmationModal 
                        modalMessage={"Are you sure you want to reset font settings?"}
                        confirmFunc={resetFontSettings}
                        cancelFunc={setShowFontResetModal}
                    />
                :
                    null
            }
        </>
        
    );
}

export default MainMenu;